import { combineReducers, configureStore } from '@reduxjs/toolkit';

import { useDispatch } from 'react-redux';
import extrajudicialNotificationsFiltersStore from './reducers/ejn-filters';
import extrajudicialNotificationsStore from './reducers/ejn-list';
import extrajudicialNotificationSelectedSlice from './reducers/ejn-selected';
import extrajudicialNotificationsToogleStore from './reducers/ejn-toogle';
import feedbackStore from './reducers/feedback';

const rootReducer = combineReducers({
  extrajudicialNotificationsFiltersStore,
  extrajudicialNotificationsToogleStore,
  extrajudicialNotificationsStore,
  extrajudicialNotificationSelectedSlice,
  feedbackStore,
});

export const setupStore = (preloadedState?: Partial<RootState>) => {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
  });
};

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];
export const useAppDispatch = () => useDispatch<AppDispatch>();
